import { createFileRoute } from '@tanstack/react-router';
import DeleteAccountSuccessPage from '@/features/account/delete-account-success';

export const Route = createFileRoute('/conta-excluida')({
  component: DeleteAccountSuccessPage,
});
